import React from "react";
import PropTypes from "prop-types";
import { Field, FieldArray } from "redux-form";
import { renderSelectField } from "../../../utils/formUtils";
import PrivacyDropdown from "../PrivacyDropdown/PrivacyDropdown";
import CatgoryDropdown from "../CategoryDropdown/CatgoryDropdown";
import { Translate } from "react-localize-redux";
import "./style.scss";

const createDefaultEntry = (items, defaultEntry, index = null) => {
  if (defaultEntry) {
    return {
      ...defaultEntry,
      order_index: index || items.length + 1
    };
  }

  return {
    number: "",
    privacy: "PU",
    category: "Home",
    order_index: items.length + 1
  };
};

const createOrderOptions = fields => {
  return fields.map((field, index) => ({ id: index + 1, text: index + 1 }));
};

export class IndexedFormRow extends React.Component {
  fieldItemDelete = (fields, indexToDelete) => {
    const _arr = fields.getAll();
    _arr.splice(indexToDelete, 1)

    fields.removeAll();

    _arr.forEach((item, index) => {

      const target_index = index + 1;

      if (item.order_index !== target_index) {
        item.order_index = parseInt(target_index);
      }
    });

    _arr.sort((obj1, obj2) => obj1.order_index - obj2.order_index);

    _arr.map((item, index) => fields.insert(index, item));
  }

  reOrderItems = (event, fields, changedFieldIndex) => {
    const newIndexValue = parseInt(event.target.value);
    const previousIndexValue = parseInt(
      fields.get(changedFieldIndex).order_index
    );

    if (newIndexValue !== previousIndexValue) {
      const _arr = fields.getAll();

      fields.removeAll();

      _arr.forEach(item => {
        if (item.order_index === newIndexValue) {
          item.order_index = previousIndexValue;
        } else if (item.order_index === previousIndexValue) {
          item.order_index = newIndexValue;
        } else {
          item.order_index = parseInt(item.order_index);
        }
      });

      _arr.sort((obj1, obj2) => obj1.order_index - obj2.order_index);

      _arr.map((item, index) => fields.insert(index, item));

      event.preventDefault();
    }
  };

  renderItemRows = ({ fields }) => {
    const {
      addComponent,
      dataComponent,
      defaultEntry,
      defaultEntries,
      privacyRow,
      renderDefaultEntry,
      showCategory,
      showPrivacy,
      showPrivacyRow,
      showIndex,
      showRemove,
      showRow,
    } = this.props;

    if (!fields.length && renderDefaultEntry) {
      if (defaultEntries) {
        defaultEntries.forEach((entry, index) =>
          fields.push(createDefaultEntry(fields, entry, index + 1))
        );
      } else {
        fields.push(createDefaultEntry(fields, defaultEntry));
      }
    }

    return (
      <React.Fragment>
        <ul>
          {fields.map(
            (member, index) =>
              showRow(fields.get(index)) && (
                <li key={index}>
                  {/* Main row: index + data input + dropdowns (desktop) */}
                  <div className="form-row">
                    {showIndex && (
                      <div className="col-2">
                        <Field
                          hideLabel={true}
                          name={`${member}.order_index`}
                          type="number"
                          hideBlankOption={true}
                          className="index-select"
                          component={renderSelectField}
                          onBlur={event => event.preventDefault()}
                          selectOptions={createOrderOptions(fields)}
                          selectOptionValue={"id"}
                          selectOptionText={"text"}
                          onChange={event =>
                            this.reOrderItems(event, fields, index)
                          }
                        />
                      </div>
                    )}

                    {!showCategory && !showPrivacy ? (
                      <div className="col-9">
                        {dataComponent(member, fields.get(index))}
                      </div>
                    ) : (
                      <div className="col">
                        {dataComponent(member, fields.get(index))}
                      </div>
                    )}
                    {showCategory && (
                      <div className="col-2 d-none d-md-block">
                        <CatgoryDropdown selectName={`${member}.category`} />
                      </div>
                    )}
                    {showPrivacy && (
                      <div className="col-1 d-none d-md-block">
                        <PrivacyDropdown
                          selectLabel={<Translate id="PrivacyText" />}
                          selectName={`${member}.privacy`}
                        />
                      </div>
                    )}
                    {showRemove && (
                      <div className="col-1">
                        <button
                          className="btn btn-primary add-btn"
                          type="button"
                          onClick={() => this.fieldItemDelete(fields, index)}
                        >
                          <i className="fa fa-trash" />
                        </button>
                      </div>
                    )}
                  </div>
                  {/* Mobile-only row: category + privacy dropdowns below input */}
                  {(showCategory || showPrivacy) && (
                    <div className="form-row d-flex d-md-none">
                      {showIndex && <div className="col-2" />}
                      {showCategory && (
                        <div className="col-auto">
                          <CatgoryDropdown selectName={`${member}.category`} />
                        </div>
                      )}
                      {showPrivacy && (
                        <div className="col-auto">
                          <PrivacyDropdown
                            selectLabel={<Translate id="PrivacyText" />}
                            selectName={`${member}.privacy`}
                          />
                        </div>
                      )}
                    </div>
                  )}
                </li>
              )
          )}
          <li>
            {addComponent ? (
              addComponent(data =>
                fields.push(createDefaultEntry(fields, data))
              )
            ) : (
              <button
                className="btn btn-primary add-btn"
                type="button"
                onClick={() =>
                  fields.push(
                    createDefaultEntry(fields, defaultEntry)
                  )
                }
              >
                <i className="fa fa-plus" /> <Translate id="addText" />
              </button>
            )}
          </li>
        </ul>
      </React.Fragment>
    );
  };

  render() {
    const { modelArrayName } = this.props;

    return (
      <FieldArray
        name={modelArrayName}
        component={this.renderItemRows}
        rerenderOnEveryChange={true}
      />
    );
  }
}

IndexedFormRow.propTypes = {
  defaultEntry: PropTypes.object,
  defaultEntries: PropTypes.func,
  addComponent: PropTypes.func,
  dataComponent: PropTypes.func,
  modelArrayName: PropTypes.string,
  renderDefaultEntry: PropTypes.bool,
  showCategory: PropTypes.bool,
  showIndex: PropTypes.bool,
  showPrivacy: PropTypes.bool,
  showPrivacyRow: PropTypes.bool,
  showRemove: PropTypes.bool,
  showRow: PropTypes.func
};

IndexedFormRow.defaultProps = {
  defaultEntry: null,
  defaultEntries: null,
  renderDefaultEntry: true,
  showCategory: true,
  showIndex: true,
  showPrivacy: true,
  showPrivacyRow: true,
  showRemove: false,
  showRow: () => true
};

export default IndexedFormRow;



// WEBPACK FOOTER //
// ./src/components/forms/IndexedFormRow/IndexedFormRow.jsx